/**
 * v1.22.0 — Central rule for balance colouring across the app.
 *
 * Business convention (per user, Feb 28 2026):
 *   Positive balance  → party owes us (RECEIVABLE) → GREEN
 *   Negative balance  → we owe party (PAYABLE / advance) → RED
 *   Zero              → slate (neutral)
 */

/**
 * @param {number|string} n
 * @param {"text"|"bg-soft"|"pill"} kind — which kind of colour bundle to return
 * @returns {string} Tailwind classes
 */
export function balanceCls(n, kind = "text") {
    const v = Number(n) || 0;
    if (kind === "text") {
        if (v > 0) return "text-emerald-700 font-semibold";
        if (v < 0) return "text-rose-700 font-semibold";
        return "text-slate-600";
    }
    if (kind === "bg-soft") {
        if (v > 0) return "text-emerald-800 bg-emerald-50";
        if (v < 0) return "text-rose-800 bg-rose-50";
        return "text-slate-700 bg-slate-50";
    }
    if (kind === "pill") {
        if (v > 0) return "bg-emerald-100 text-emerald-800";
        if (v < 0) return "bg-rose-100 text-rose-800";
        return "bg-slate-100 text-slate-700";
    }
    return "";
}

/**
 * Human-readable direction label — "Receivable" (they owe us), "Payable"
 * (we owe them), or "Settled".
 */
export function balanceLabel(n) {
    const v = Number(n) || 0;
    if (v > 0) return "Receivable";
    if (v < 0) return "Payable";
    return "Settled";
}
